<template>
    <div class="row div-spacing-top">
        <loading-component v-if="isLoadingAddress"></loading-component>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="order-title">
                Additional Information
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top" v-if="!Order.IsExamOnly">
            <div class="row no-gutters order-div">
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <p>Shipping Address:
                        <span data-balloon="This is the default shipping address for this account. To edit this address, go to the “My Account” page." data-balloon-pos="down" data-balloon-length="large">
                            <i class="fa fa-question-circle-o"></i>
                        </span>
                    </p>
                </div>
                <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                    <div class="row">
                        <div v-if="!Order.ShippingUseDifferent && !$route.params.code" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <span v-if="Account.accountType != '1'" class="font-order">{{Account.primaryContact.legalName}}</span>
                            <span v-else class="font-order">{{Account.primaryContact.firstName}} {{Account.primaryContact.lastName}}</span><br>
                            <span class="font-order">{{Account.primaryContact.officeLocation.streetAddress}} {{Account.primaryContact.officeLocation.suite}}</span><br>
                            <span class="font-order">{{Account.primaryContact.officeLocation.city}}, {{Account.primaryContact.officeLocation.state}} {{Account.primaryContact.officeLocation.zip}}</span><br>
                            <br>
                        </div>
                        <div v-if="!Order.ShippingUseDifferent && $route.params.code">
                            <span class="font-order">{{Order.ShippingFullName}}</span><br>
                            <span class="font-order">{{Order.ShippingAddressLineOne}}</span><br>
                            <span class="font-order">{{Order.ShippingAddressLineTwo}}</span><br>
                            <span class="font-order">{{Order.ShippingCity}}, {{Order.ShippingState}} {{Order.ShippingPostcode}}</span><br>
                            <br>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="form-check">
                                <input :disabled="Order.RemakeRedoReason === 'OTH-LABREDO'" v-model="Order.ShippingUseDifferent" type="checkbox" class="form-check-input">
                                <span class="form-check-label g-font-size-18">Use a different shipping address for this order</span>
                            </div>
                        </div>
                        <div v-if="Order.ShippingUseDifferent && MasterAccountType != 'master'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>Location Name*</label>
                                <input v-model="Order.ShippingFullName" v-bind:class="{ error_field: ValidationResult.OrderShippingFullName }" type="text" class="form-control">
                            </div>
                            <p class="error-message" v-if="ValidationResult.OrderShippingFullName">{{ValidationResult.OrderShippingFullName}}</p>
                        </div>
                        <div v-if="Order.ShippingUseDifferent" class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>Street Address*</label>
                                <input v-model="Order.ShippingAddressLineOne" v-bind:class="{ error_field: ValidationResult.OrderShippingAddressLineOne }" @change="addressChanged" type="text" class="form-control">
                                <p class="error-message" v-if="ValidationResult.OrderShippingAddressLineOne">{{ValidationResult.OrderShippingAddressLineOne}}</p>
                            </div>
                        </div>
                        <div v-if="Order.ShippingUseDifferent" class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>Suite</label>
                                <input v-model="Order.ShippingSuite" type="text" class="form-control">
                            </div>
                        </div>
                        <div v-if="Order.ShippingUseDifferent" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>City*</label>
                                <input v-model="Order.ShippingCity" v-bind:class="{ error_field: ValidationResult.OrderShippingCity }" type="text" class="form-control">
                                <p class="error-message" v-if="ValidationResult.OrderShippingCity">{{ValidationResult.OrderShippingCity}}</p>
                            </div>
                        </div>
                        <div v-if="Order.ShippingUseDifferent" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>State*</label>
                                <select v-model="Order.ShippingState" v-bind:class="{ error_field: ValidationResult.OrderShippingState}" class="form-control" style="height:36.5px;">
                                    <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option>
                                </select>
                                <p class="error-message" v-if="ValidationResult.OrderShippingState">{{ValidationResult.OrderShippingState}}</p>
                            </div>
                        </div>
                        <div v-if="Order.ShippingUseDifferent" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div v-if="Order.ShippingUseDifferent" class="form-group">
                                <label>Zip*</label>
                                <span v-if="isValidAddress">
                                    <i class="fa fa-check-circle check_icon"></i>
                                </span>
                                <input v-model="Order.ShippingPostCode" v-bind:class="{ error_field: ValidationResult.OrderShippingPostCode }" v-on:keypress="G_NumberCheck(this.event)" v-on:blur="ValidateAddress()" maxlength="5" type="text" class="form-control">
                                <p class="error-message" v-if="ValidationResult.OrderShippingPostCode">{{ValidationResult.OrderShippingPostCode}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="MasterAccountType == 'master'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-group order-div">
                <label>Assigned Lab</label>
                <multiselect v-model="Order.OrderLab" deselectLabel=" " label="name" :options="labList" selectedLabel=" " placeholder=" " selectLabel=" ">
                    <span slot="noResult">No elements found.</span>
                </multiselect>
            </div>
        </div>
        <div v-if="MasterAccountType == 'master'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
            <div class="row no-gutters order-div">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>Special Instructions For Lab</label>
                        <textarea v-model="Order.SpecialLabInstructions" row="3" class="form-control"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="Order.ShowExtraStudentFields == true" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-group center order-div">
                <label>Manifest Distance Acuity</label>
                <div class="right">
                </div>
                <div class="row">
                     <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>RE/OD</label>
                            <input v-on:keyup="acuityPrefixR()" placeholder="20/" class="form-control" v-model="Order.ReManifestAcuity"></input>
                        </div>
                     </div>
                     <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>LE/OS</label>
                            <input v-on:keyup="acuityPrefixL()" placeholder="20/" class="form-control" v-model="Order.LeManifestAcuity"></input>
                        </div>
                     </div>
                </div>
            </div>
        </div>
        <div v-if="(!Order.IsExamOnly && Order.ShowExtraStudentFields == true)" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-group center order-div">
                <label>Wearing Instructions</label>
                <div class="right">
                </div>
                <div class="row">
                     <div class="col-lg-12 col-md-12 col-sm-6 col-xs-6">
                         <div class="form-group">
                        <label>Patient should wear glasses:</label> 
                        <select v-model="Order.PatWearingInstructions" class="form-control" style="height:36.5px;">
                            <option value="FullTime">Full-time</option>
                            <option value="Distance">For distance only</option>
                            <option value="Near">For near vision only</option>
                        </select>
                        </div>
                     </div>
                </div>
            </div> 
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
            <div class="row no-gutters order-div">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>Patient/Order Notes (not sent to lab)</label>
                        <p>This information is for your internal use only and will not be shared with the laboratory</p>
                        <textarea v-model="Order.DispenserNotes" row="3" class="form-control"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoadingComponent from "@/components/shared/LoadingComponent";
import Multiselect from "vue-multiselect";
export default {
  props: ["Order", "Account", "State", "ValidationResult", "MasterAccountType"],
  components: { LoadingComponent, Multiselect },
  data() {
    return {
      isLoadingAddress: false,
      isValidAddress: false,
      labList: [],
      selectedLab: null
    };
  },
  methods: {
    addressChanged(evt){
        // this.Order.ShippingAddressLineOne = this.RemovePOBOX(this.Order.ShippingAddressLineOne.toString())
        if(this.Order.ShippingAddressLineOne){
        let check_PO_BOX  = this.checkIfAddressHasPO_BOX(this.Order.ShippingAddressLineOne.toString()) 
        if(check_PO_BOX == true){
          alert("Sorry, our labs cannot ship to a PO BOX. Please enter a valid shipping address.")
          return
        }
      }
    },
    acuityPrefixR(){
    var prefix = "20/"
            if(this.Order.ReManifestAcuity.indexOf(prefix) !== 0 
                & this.Order.ReManifestAcuity != ''){
            this.Order.ReManifestAcuity = prefix + this.Order.ReManifestAcuity;
    }
    },
    acuityPrefixL(){
          var prefix = "20/"
            if(this.Order.LeManifestAcuity.indexOf(prefix) !== 0 
                & this.Order.LeManifestAcuity != ''){
            this.Order.LeManifestAcuity = prefix + this.Order.LeManifestAcuity;
    }
    },
    ValidateAddress() {
      this.isLoadingAddress = true;
      var _this = this;
      if (true) {
        var params = {
          Address2: this.Order.ShippingAddressLineOne,
          City: this.Order.ShippingCity,
          State: this.Order.ShippingState,
          Zip5: this.Order.ShippingPostcode,
          Suite: this.Order.ShippingSuite
        };
        axios
          .post("/Account/GetAddressDetails/", params)
          .then(response => {
            if (response.data.isSuccess) {
              var details = response.data.raw;

              _this.isLoadingAddress = false;
              _this.isValidAddress = true;

              _this.Order.ShippingAddressLineOne = details.address2;
              _this.Order.ShippingAddressLineTwo = details.suite;
              _this.Order.ShippingCity = details.city;
              _this.Order.ShippingState = details.state;
              _this.Order.ShippingPostCode = details.zip5;

              _this.ValidationResult.OrderShippingPostCode = null;
            } else {
              _this.isLoadingAddress = false;
              _this.isValidAddress = false;

              _this.ValidationResult.OrderShippingPostCode =
                response.data.errorMessage;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    GetOrderLab() {
      var _this = this;
      axios
        .get("Account/GetOrderLab", {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(function(response) {
          _this.labList = response.data.raw;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  created() {
    if (this.MasterAccountType == "master") {
      this.GetOrderLab();
    }
  }
};
</script>


// WEBPACK FOOTER //
// AdditionalInformation.vue?a047c250